import { ListTonesDto } from '../../../dto/listtones/listtonesdto';
import { MiddlewareDtoImpl } from '../../../dto/middlewaredto';
import { MiddlewareAPIResponse } from '../../middlewareapiresponse';

export interface ListTonesResponse extends MiddlewareAPIResponse
{
    getListTonesResponseDtos(): ListTonesDto[];
    getStatusTonesDtos(): ListTonesDto[];
}

export class ListTonesResponseDtoImpl extends MiddlewareDtoImpl implements ListTonesResponse
{
    private getListTonesDto : ListTonesDto[];
    private getStatusTonesDto : ListTonesDto[];

    getListTonesResponseDtos(): ListTonesDto[]
    {
        return this.getListTonesDto;
    }

    getStatusTonesDtos(): ListTonesDto[] {
       return this.getStatusTonesDto;
    }
    setListTonesResponseDtos(getListTonesDto: ListTonesDto[])
    {
        this.getListTonesDto = getListTonesDto;
    }

    setStatusTonesResponseDtos(getListTonesDto: ListTonesDto[])
    {
        this.getStatusTonesDto = getListTonesDto;
    }
}



// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/api/mytunes/listtones/listtonesresponse.tsx